export default "__VITE_ASSET__BbQgoGBB__"